/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
import React, { Fragment } from "react";
import styles from "./handle.css";
import PropTypes from "prop-types";
const Handle = ({
    domain: [min, max],
    handle: { id, value, percent },
    disabled,
    getHandleProps,
    animatedHandle,
    handleColor,
    getHandleID,
    percentageHandler,
    showPercentage,
    handleStyle
}) => {
    const handleBackgroundImage = () => {
        switch (handleColor) {
            case "orange": return "linear-gradient(225deg, #6B5CFF, #4736FE)";
            case "white": return "linear-gradient(269deg, #ffffff, #ffffff)";
            case "blue": return "linear-gradient(269deg, #0071BC, #0071BC)";
            default: return "linear-gradient(225deg, #6B5CFF, #4736FE)";
        }
    };
    return (
        <Fragment>
            <div
                style={{
                    left: `${percent}%`,
                    position: "absolute",
                    transform: "translate(-50%, -50%)",
                    WebkitTapHighlightColor: "rgba(0,0,0,0)",
                    zIndex: 5,
                    width: 28,
                    height: 42,
                    cursor: "pointer",
                    // border: '1px solid white',
                    backgroundColor: "none"
                }}
                {...getHandleProps(id)}
                {...getHandleID(id)}
            />
            <div
                styleName={showPercentage ? "styles.sliderSquare" : "styles.sliderCircle"}
                className={
                    animatedHandle ? `rippleEffect ${handleColor || "orange sliderCircleClass"}` : "sliderCircleClass"
                }
                role="slider"
                aria-valuemin={min}
                aria-valuemax={max}
                aria-valuenow={value}
                style={{
                    left: `${percent}%`,
                    backgroundImage: disabled
                        ? "#fff"
                        : handleBackgroundImage(),
                        ...handleStyle
                }}
            >
                {showPercentage && `${Math.floor(percentageHandler(value))}%`}
            </div>
        </Fragment>
    );
};

Handle.propTypes = {
    domain: PropTypes.array.isRequired,
    handle: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired
    }).isRequired,
    getHandleProps: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    animatedHandle: PropTypes.bool,
    handleColor: PropTypes.string,
    getHandleID: PropTypes.func,
    percentageHandler: PropTypes.func,
    showPercentage: PropTypes.bool,
    handleStyle: PropTypes.object
};

Handle.defaultProps = {
    disabled: false
};

export default Handle;
